import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

/**
 * Dispara PageView do Meta Pixel a cada mudança de rota (SPA).
 * O PageView inicial já é enviado pelo snippet no index.html.
 */
const MetaPixelTracker = () => {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    try {
      window.fbq?.("track", "PageView");
    } catch {
      // nunca quebrar a navegação por causa do pixel
    }
  }, [pathname]);

  return null;
};

export default MetaPixelTracker;
